/* Scent Quiz — address autocomplete (Google Places API (New)).
   Loaded by sections/scent-quiz.liquid ONLY when a Places API key is set in the section settings.
   Without a key this file is never requested and the quiz contains no Places code. */
(function(){
  "use strict";
  var placesLib = null;   /* shared across form re-renders (Back / forward) */

  window.initScentQuizPlaces = function(ctx){
    var ROOT = ctx.root, cfg = ctx.cfg, esc = ctx.esc, track = ctx.track;
    if(!cfg.placesApiKey) return;

  /* ===== ADDRESS AUTOCOMPLETE — Google Places API (New). Optional: only active when a key is set in the section settings.
     Suggestions appear under the street field; choosing one fills street, city, state and ZIP. Every field stays editable,
     and if Google fails to load the form simply works as a plain form. ===== */
  function loadPlaces(){
    if(placesLib) return placesLib;
    placesLib = new Promise(function(resolve, reject){
      function ready(){ google.maps.importLibrary("places").then(resolve, reject); }
      if(window.google && google.maps && google.maps.importLibrary){ ready(); return; }
      var cb = "__sqMapsReady_" + String(cfg.sectionId).replace(/\W/g, "_");
      window[cb] = ready;
      var s = document.createElement("script");
      s.async = true;
      s.src = "https://maps.googleapis.com/maps/api/js?key=" + encodeURIComponent(cfg.placesApiKey) + "&loading=async&v=weekly&callback=" + cb;
      s.onerror = function(){ reject(new Error("Google Maps script failed to load")); };
      document.head.appendChild(s);
    });
    placesLib.catch(function(e){ console.warn("[scent-quiz] address autocomplete unavailable:", e); });
    return placesLib;
  }

  function initAddressAutocomplete(){
    if(!cfg.placesApiKey) return;
    var input = ROOT.querySelector("#st");
    if(!input) return;

    /* wrap the input so the list can sit directly beneath it */
    var wrap = document.createElement("div");
    wrap.className = "sq-ac";
    input.parentNode.insertBefore(wrap, input);
    wrap.appendChild(input);
    var list = document.createElement("ul");
    list.className = "sq-places";
    list.id = "sq-places-" + cfg.sectionId;
    list.setAttribute("role", "listbox");
    list.setAttribute("aria-label", "Address suggestions");
    list.hidden = true;
    wrap.appendChild(list);
    input.setAttribute("autocomplete", "off");
    input.setAttribute("role", "combobox");
    input.setAttribute("aria-autocomplete", "list");
    input.setAttribute("aria-expanded", "false");
    input.setAttribute("aria-controls", list.id);

    var token = null, timer = null, items = [], active = -1, seq = 0, failures = 0, useTypes = true;

    function close(){
      list.hidden = true; active = -1;
      input.setAttribute("aria-expanded", "false");
      input.removeAttribute("aria-activedescendant");
    }
    function setActive(i){
      active = i;
      var opts = list.querySelectorAll('[role="option"]');
      for(var k = 0; k < opts.length; k++){ opts[k].setAttribute("aria-selected", k === i ? "true" : "false"); }
      if(i > -1 && opts[i]){ input.setAttribute("aria-activedescendant", opts[i].id); } else { input.removeAttribute("aria-activedescendant"); }
    }
    function render(){
      list.innerHTML = "";
      items.forEach(function(it, i){
        var li = document.createElement("li");
        li.className = "sq-place"; li.id = list.id + "-" + i;
        li.setAttribute("role", "option"); li.setAttribute("aria-selected", "false");
        li.innerHTML = '<span class="sq-place-main">' + esc(it.main) + '</span><span class="sq-place-sub">' + esc(it.sub) + '</span>';
        li.addEventListener("mousedown", function(e){ e.preventDefault(); choose(i); });
        li.addEventListener("mousemove", function(){ if(active !== i) setActive(i); });
        list.appendChild(li);
      });
      if(items.length){
        var attr = document.createElement("li");
        attr.className = "sq-places-attr"; attr.setAttribute("role", "presentation"); attr.textContent = "Powered by Google";
        list.appendChild(attr);
      }
      active = -1;
      list.hidden = !items.length;
      input.setAttribute("aria-expanded", items.length ? "true" : "false");
    }

    function query(){
      var text = input.value.trim();
      if(failures >= 3 || text.length < 3){ items = []; close(); return; }
      var mine = ++seq;
      loadPlaces().then(function(lib){
        if(!token) token = new lib.AutocompleteSessionToken();
        var req = {input: text, sessionToken: token, includedRegionCodes: ["us"]};
        if(useTypes) req.includedPrimaryTypes = ["street_address", "subpremise", "premise"];
        return lib.AutocompleteSuggestion.fetchAutocompleteSuggestions(req).catch(function(e){
          if(!useTypes) throw e;
          useTypes = false;                          /* retry once without the address-type filter */
          delete req.includedPrimaryTypes;
          return lib.AutocompleteSuggestion.fetchAutocompleteSuggestions(req);
        });
      }).then(function(res){
        if(mine !== seq) return;                     /* a newer keystroke superseded this request */
        failures = 0;
        items = (res.suggestions || []).filter(function(s){ return s.placePrediction; }).slice(0, 5).map(function(s){
          var pp = s.placePrediction;
          return {main: pp.mainText ? pp.mainText.text : pp.text.text, sub: pp.secondaryText ? pp.secondaryText.text : "", pred: pp};
        });
        render();
      }).catch(function(e){
        failures++;
        console.warn("[scent-quiz] address lookup failed:", e);
        items = []; close();
      });
    }

    function put(id, value){
      var el = ROOT.querySelector("#" + id);
      if(!el || !value) return;
      el.value = value;
      el.dispatchEvent(new Event("input", {bubbles: true}));   /* clears any validation error on that field */
    }
    function fillFrom(comps){
      function get(type, short){
        for(var i = 0; i < comps.length; i++){
          if(comps[i].types.indexOf(type) > -1) return short ? comps[i].shortText : comps[i].longText;
        }
        return "";
      }
      var street = [get("street_number"), get("route")].filter(Boolean).join(" ");
      var unit = get("subpremise");
      if(unit){ street += (/^(apt|unit|suite|ste|#)/i.test(unit) ? ", " : ", #") + unit; }
      put("st", street);
      put("ci", get("locality") || get("postal_town") || get("sublocality_level_1") || get("sublocality") || get("administrative_area_level_3"));
      put("sr", get("administrative_area_level_1", true));
      put("zp", get("postal_code"));
    }

    function choose(i){
      var it = items[i];
      if(!it) return;
      close();
      input.value = it.main;
      var place = it.pred.toPlace();
      place.fetchFields({fields: ["addressComponents"]}).then(function(){
        fillFrom(place.addressComponents || []);
        token = null;                                /* choosing a place ends the billing session */
        track("quiz_address_autofill");
      }).catch(function(e){ console.warn("[scent-quiz] address details failed:", e); });
    }

    input.addEventListener("input", function(){ clearTimeout(timer); timer = setTimeout(query, 220); });
    input.addEventListener("focus", function(){ loadPlaces(); });
    input.addEventListener("blur", function(){ setTimeout(close, 150); });
    input.addEventListener("keydown", function(e){
      if(list.hidden || !items.length) return;
      if(e.key === "ArrowDown"){ e.preventDefault(); setActive((active + 1) % items.length); }
      else if(e.key === "ArrowUp"){ e.preventDefault(); setActive((active - 1 + items.length) % items.length); }
      else if(e.key === "Enter"){ if(active > -1){ e.preventDefault(); choose(active); } }
      else if(e.key === "Escape"){ close(); }
    });
  }

    initAddressAutocomplete();
  };
})();
